module.exports = __webpack_public_path__ + "static/media/dcdb-papa-hero-desktop.431c9eb4.jpg";